import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useListenUserChanges } from '../utils/db';
import { useFirebaseLoginState } from '../utils/hooks';
import { RootState } from '../utils/store';
import { Item, RequestType } from '../utils/types';

const LEGACY_FB_TYPES: RequestType[] = [
  RequestType.FACEBOOK_POSTS,
  RequestType.FACEBOOK_POST_IDEAS,
  RequestType.FACEBOOK_EDUCATIONAL_POST,
];

export function useLegacyFacebookItems() {
  const { userId } = useFirebaseLoginState();
  const { dbUser } = useListenUserChanges(userId);
  const campaign = useSelector((s: RootState) => s.appState.selectedCampaign);
  const items = campaign?.items || [];

  // Filter and sort legacy Facebook items
  const legacyItems = useMemo(
    () =>
      (items as Item[])
        .filter((item) => LEGACY_FB_TYPES.includes(item.type))
        .sort(
          (a, b) => (b.created_at?.getTime() ?? 0) - (a.created_at?.getTime() ?? 0)
        ),
    [items]
  );

  // Check if banner is dismissed for this campaign
  const campaignId = campaign?.id;
  const isDismissed = useMemo(() => {
    if (!campaignId || !dbUser?.flags?.banners) {
      return false;
    }

    const legacyPreviewFlags = dbUser.flags.banners['legacy-preview'];
    if (!legacyPreviewFlags?.facebook) {
      return false;
    }

    return legacyPreviewFlags.facebook[`${campaignId}_dismissed`] === true;
  }, [dbUser?.flags?.banners, campaignId]);

  return {
    legacyItems,
    isDismissed,
    hasLegacyItems: legacyItems.length > 0,
  };
}
